import SimpleVirtualizedVehicleList from '@/components/ui/vehicle-list/simple-virtualized-vehicle-list';
import { useVehiclesContext } from '@/contexts/vehicles-provider';
import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

const AvailablePage = observer(() => {
  const { availableVehicles, searchFilterCallback } = useVehiclesContext();
  return (
    <div>
      <SimpleVirtualizedVehicleList
        vehicleListingsData={availableVehicles}
        filterCallback={() => true}
        findInViewFilterCallback={searchFilterCallback}
        enableScope={() => {}}
      />
    </div>
  );
});

export const Route = createFileRoute('/(authenticated)/cars/available/')({
  component: AvailablePage,
});
